/* eslint-disable react/no-array-index-key */
// We are not reordering any items in list so index should suffice as key

import React from 'react'
import { Credibility as CredibilityType } from '@chegg-wt/core/types/core'
import { LvpMarginWrapper } from '../Layouts/LargeVideoPlayerLayout'

import * as Styled from './styled'

interface Props {
  copy: CredibilityType
  advertPlacement?: string
}

const Credibility: React.FunctionComponent<Props> = ({
  copy,
  advertPlacement,
}: Props) => (
  <Styled.Container>
    <LvpMarginWrapper>
      {advertPlacement ? <Styled.Advert placement={advertPlacement} /> : null}
      <Styled.Content>
        <Styled.Header>{copy.header}</Styled.Header>
        {copy.body.map(({ header, body, isList = true, tabbed = false }, index) => (
          <div key={index}>
            {header && <Styled.ListHeader>{header}</Styled.ListHeader>}
            {isList ? (
              <Styled.List>
                {body.map((item, index) => (
                  <Styled.BulletPoint tabbed={tabbed} key={index}>
                    {item}
                  </Styled.BulletPoint>
                ))}
              </Styled.List>
            ) : (
              <>
                {body.map((item, index) => (
                  <Styled.Paragraph key={index}>{item}</Styled.Paragraph>
                ))}
              </>
            )}
          </div>
        ))}
      </Styled.Content>
    </LvpMarginWrapper>
  </Styled.Container>
)

export default Credibility
